import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=8b4d73b2&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4d73b2",
  null
  
)

export default component.exports